import "./src/styles/fonts.css";
import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { initTracking, cleanUrlForFacebook } from './src/utils/tracking';

export const onClientEntry = () => {
  initTracking();
};

export const wrapRootElement = ({ element }) => {
  return <HelmetProvider>{element}</HelmetProvider>;
};

// Отправляем событие PageView при каждой смене страницы
// ВАЖНО: Facebook не рекомендует отправлять PageView при изменении только хеша
// Для расцветок товаров используется событие ViewContent, а не PageView
export const onRouteUpdate = ({ location, prevLocation }) => {
  if (typeof window !== 'undefined' && window.fbq) {
    const currentPathname = location.pathname;
    const prevPathname = prevLocation?.pathname || '';
    
    // Используем window.location.hash для более надежной проверки хеша
    // location.hash из Gatsby может быть не синхронизирован с реальным URL
    const currentHash = typeof window !== 'undefined' ? (window.location.hash || '') : (location.hash || '');
    const prevHash = prevLocation?.hash || '';
    
    // Отправляем PageView только если:
    // 1. Это первая загрузка страницы (prevLocation отсутствует) И pathname изменился
    // 2. Или pathname изменился (реальная смена страницы)
    // НЕ отправляем если изменился только хеш (pathname одинаковый, но hash разный)
    const isPathnameChanged = currentPathname !== prevPathname;
    const isOnlyHashChanged = currentPathname === prevPathname && currentHash !== prevHash && currentHash !== '';
    
    // НЕ отправляем PageView если изменился только хеш (переключение расцветки)
    if (isOnlyHashChanged) {
      console.log('🟡 [PageView] Skipped - only hash changed, pathname:', currentPathname, 'hash:', currentHash);
      return;
    }
    
    // Отправляем PageView только если:
    // 1. Это первая загрузка страницы (prevLocation отсутствует)
    // 2. Или pathname изменился (реальная смена страницы)
    if (!prevLocation || isPathnameChanged) {
      // Используем window.location.href для получения полного URL с маркетинговыми параметрами
      // Функция cleanUrlForFacebook очистит их, но оставит хеш (если он есть)
      const fullUrl = typeof window !== 'undefined' && window.location ? window.location.href : '';
      if (!fullUrl || typeof fullUrl !== 'string') {
        console.warn('🟡 [PageView] Invalid URL, skipping');
        return;
      }
      const cleanUrl = cleanUrlForFacebook(fullUrl);
      // Оставляем хеш в page_path, так как Facebook автоматически захватывает URL с хешем
      const pagePath = cleanUrl; // Не убираем хеш, оставляем как есть
      
      if (pagePath && typeof pagePath === 'string') {
        window.fbq('track', 'PageView', {
          page_path: pagePath,
          cache_buster: Math.random()
        });
        console.log('🟡 [PageView] Event sent for path:', pagePath);
      } else {
        console.warn('🟡 [PageView] Invalid pagePath, skipping:', pagePath);
      }
    } else {
      // Если pathname не изменился - не отправляем PageView
      console.log('🟡 [PageView] Skipped - same pathname:', currentPathname);
    }
  }
};
